import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { MerchantStorefront } from '../components/shop/MerchantStorefront';
import { easyleaseConfig } from '../data/shopConfig';
/**
 * The public merchant shop at talab.app/shop/<handle>. It renders the one
 * MerchantStorefront implementation with the merchant's PUBLISHED config —
 * the Business Hub preview renders the very same component with the draft.
 *
 * The page intentionally carries no app chrome, so it also carries its own
 * quiet way back to Talab for anyone who arrived from inside the product.
 */
export function Shop() {
  const navigate = useNavigate();
  return <>
      <MerchantStorefront config={easyleaseConfig} data-id="element-6046" data-mp="3998epzc0kwbi" />
      <button onClick={() => navigate('/business')} className="fixed bottom-5 left-5 z-[90] inline-flex items-center gap-2 pl-3 pr-4 py-2.5 bg-dark-navy/90 backdrop-blur-sm text-white rounded-full text-[13px] font-semibold shadow-lg hover:bg-dark-navy transition-colors duration-150 ease-out" data-id="element-6047" data-mp="397nkkatm3fe6">
        <ArrowLeftIcon className="w-4 h-4" data-id="element-6048" data-mp="3dih44ebjz6jh" />
        Back to Talab
      </button>
    </>;
}